import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';
import { PrayerCompanionSettings, usePrayerCompanionProvider } from './PrayerCompanionSettings';
import { GuidanceProvider } from '@/contexts/settings/types';
import { LAYERS } from '@/utils/layers';

interface CompanionSettingsDialogProps {
  onProviderChange?: (provider: GuidanceProvider) => void;
}

export const CompanionSettingsDialog: React.FC<CompanionSettingsDialogProps> = ({
  onProviderChange
}) => {
  const [open, setOpen] = useState(false);
  const currentProvider = usePrayerCompanionProvider();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <Settings className="h-4 w-4" />
          <span className="sr-only">Prayer Companion Settings</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl" style={{ zIndex: LAYERS.SECONDARY_DIALOGS }}>
        <DialogHeader>
          <DialogTitle>Prayer Companion Settings</DialogTitle>
        </DialogHeader>
        <PrayerCompanionSettings 
          onProviderChange={(provider) => {
            onProviderChange?.(provider);
            setOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};